import { RESET } from '../actionTypes';
import { configurationDocumentsActions } from '../reducer';

export default () => configurationDocumentsActions[RESET]();
